import { Injectable } from "@angular/core";
import { Store, createState, withProps, select } from "@ngneat/elf";
import { persistState, localStorageStrategy } from "@ngneat/elf-persist-state";

interface SchoolYearProps {
  schoolYears: string[];
  selectedShoolYear: string;
}

const { state, config } = createState(
  withProps<SchoolYearProps>({ schoolYears: [], selectedShoolYear: null })
);

const schoolYearStore = new Store({ state, name: "schoolYear", config });

export const persist = persistState(schoolYearStore, {
  key: schoolYearStore.name,
  storage: localStorageStrategy,
});

@Injectable({
  providedIn: "root",
})
export class SchoolYearRepository {
  currentSchoolYear$ = schoolYearStore.pipe(
    //select((state) => state.selectedShoolYear)
  );

  schoolYears$ = schoolYearStore.pipe(select((state) => state.schoolYears));

  setSelectedSchoolYear(
    selectedShoolYear: SchoolYearProps["selectedShoolYear"]
  ) {
    //schoolYearStore.update((state) => ({
    //  ...state,
    //  selectedShoolYear,
    //}));
  }

  setSchoolYears(schoolYears: SchoolYearProps["schoolYears"]) {
    //schoolYearStore.update((state) => ({
    //  ...state,
    //  schoolYears,
    //}));
  }
}
